import { Injectable } from '@angular/core';
import { ComponentStore } from '@ngrx/component-store';
import { Observable, map, of, skip, take } from 'rxjs';
import { ComponentStoreLogger } from './component.store.logger';

import { Store } from '@ngrx/store';
import * as fromStore from '../../lib';
import { Router } from '@angular/router';

// add class name ???
export interface Data {
  data: unknown;
  id: string;
  route: string;
}

export interface State {
  id: { [uuid: string]: Data };
}

@Injectable({
  providedIn: 'root',
})
export class UIStore extends ComponentStoreLogger {
  constructor(router: Router, store: Store<fromStore.DashboardState>, private readonly componentStore: ComponentStore<any>) {
    super(router, store);
    this.initStore();

    this.getUiState$.pipe(skip(1)).subscribe((data: Data) => {
      this.updateGlobalStore(data);
    });
  }

  initStore() {
    this.componentStore.setState({});
  }

  private createEntity(data: Data[], state: any) {
    const entities = data.reduce(
      (entities: { [id: string]: Data }, data: Data) => {
        return {
          ...entities,
          [data.id]: data,
        };
      },
      {
        ...state.entities,
      }
    );
    return entities;
  }

  private isKey(state: any, id: string) {
    if (state && 'entities' in state && id in state.entities) {
      return true;
    }
    return false;
  }

  private mergeData(state: any, id: string, data: any) {
    const oldData = state.entities[id].data;

    //FIXME check if array or not

    console.log('old data');
    console.log(oldData);
    // Ensure oldData is an array, defaulting to an empty array if it's not
    const newData = [...(Array.isArray(oldData) ? oldData : []), ...(Array.isArray(data) ? data : [])];

    // Prepare the temporary data object
    const tmp_data = { id: id, data: newData, route: this.getCurrentRoute };

    // Return the result from createEntity
    return this.createEntity([tmp_data], state);
  }

  public readonly getUiState$ = this.componentStore.select((state) => state.entities);

  public getStateById$(id: string): Observable<any> {
    return this.componentStore.select((state) => {
      if (state.entities && state.entities[id]) {
        return state.entities[id].data;
      }
    });
  }

  public getStateById(id: string): any {
    let state!: State;
    this.componentStore
      .select((state) => state)
      .pipe(
        take(1),
        map((state) => {
          if (state.entities && state.entities[id]) {
            return state.entities[id].data;
          }
          return [];
        })
      )
      .subscribe((s) => (state = s));
    return state;
  }

  public getStateIncludesId(id: string): Observable<any> {
    const data = [] as any;

    this.getUiState$.subscribe((state) => {
      if (state) {
        for (const [key, value] of Object.entries(state)) {
          if (key.includes(id)) {
            data.push(value);
          }
        }
      }
    });

    return of(data);
  }

  /**
   * Store a value into the ngrx component store
   * If a value will be store with an id the already
   * exists the store create an array
   * @param id a unique id to identify the store value
   * @param data the stored value
   */
  public set(id: string, data: any) {
    const newData = { id: id, data: data, route: this.getCurrentRoute };

    this.componentStore.setState((state: any) => {
      //if (state && Object.keys(state).length === 0 && Object.getPrototypeOf(state) === Object.prototype) {
      const found = this.isKey(state, id);
      if (found) {
        const entities = this.mergeData(state, id, data);

        return {
          ...state,
          entities,
        };
      }
      const entities = this.createEntity([newData], state);
      return {
        ...state,
        entities,
      };
    });
  }

  /**
   * Filter value from the store by id & index
   * @param id a unique id to identify the store value
   * @param index to filter a data set
   */
  public filter(id: string, index: number) {
    this.componentStore.setState((state: any) => {
      const data = state.entities[id].data;

      let newData = data.filter((x: any, i: number) => x.index !== index);

      newData = newData.filter(function (el: any) {
        return el != null;
      });

      const tmp_data = { id: id, data: newData, route: this.getCurrentRoute };
      const entities = this.createEntity([tmp_data], state);

      return {
        ...state,
        entities,
      };
    });
  }

  public clear(id: string) {
    this.componentStore.setState((state: any) => {
      if (state && state.entities) {
        const { [id]: removed, ...entities } = state.entities;
        return {
          ...state,
          entities,
        };
      }
      return state;
    });
  }

  public clearAll() {
    this.componentStore.setState((state: any) => {
      return {
        ...state,
        entities: {},
      };
    });
  }
  /**
   * Store a value into the ngrx component store
   * If a value will be stored with an id the already
   * exists the store will override the value
   * @param id a unique id to identify the store value
   * @param data the stored value
   */
  public update(id: string, value: any) {
    this.componentStore.setState((state: any) => {
      if (this.isKey(state, id)) {
        const oldData = state.entities[id];

        const newData = { ...oldData, ['data']: value };
        const entities = this.createEntity([newData], state);

        return {
          ...state,
          entities,
        };
      } else {
        const newData = { id: id, data: value, route: this.getCurrentRoute };
        const entities = this.createEntity([newData], state);
        return {
          ...state,
          entities,
        };
      }
    });
  }
}
